import React from 'react';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { convertByte } from '@/utils/common';
import SummaryPanel from '@/components/Cluster/SummaryPanel';
import EllipsisTip from '@/components/EllipsisTip';

/**
 * @param {Object} props
 * @returns
 */
function Summary({ overview, loading }) {
  const items = [
    {
      title: 'Auditor',
      info: <EllipsisTip style={{ marginRight: 30 }}>{overview.auditor || '-'}</EllipsisTip>,
      icon: 'other2',
    },
    {
      title: 'Worker',
      info: <CountUp end={overview.recoveryWorkerCount} duration={0.4} />,
      icon: 'other4',
    },
    {
      title: '待复制ledger',
      info: <CountUp end={overview.underReplicationLedgerCount} duration={0.4} />,
      icon: 'other3',
      unit: '个',
    },
    {
      title: '待修复数据',
      icon: 'other3',
      info: convertByte(overview.underReplicationLedgerSize || 0).pretty,
    },
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect((state) => ({
  overview: state.bookkeeper.recoveryOverview,
  loading: state.bookkeeper.loading,
}))(Summary);
